import { useAppSelector } from 'hooks/useAppDispatchSelector';
import { modalEnum } from 'helpers/utils';
import Confirmation from './confirmation';
import CompleteWorkshopAppointment from './complete-workshop-appointment';
import CancelledWorkshopAppointment from './cancelled-workshop-appointment';
import AlertTemplates from './alert-templates';
import SendAlert from './send-alert';
import AppointmentConfirmation from './appointment-confirmation';
import { memo } from 'react';
import ChangeWorkshopAppointmentStatus from './change-workshop-appointment-status';
import AddPayment from './add-payment';
import AddEditBrand from './add-edit-brand';
import AddEditModel from './add-edit-models';
import AddEditEngine from './add-edit-engine';
import AddEditTireSize from './add-edit-tiresize';
import AddEditDeviceProvider from './add-edit-device-provider';
import AddEditDevice from './add-edit-device';
import AddEditProgrammedAlert from './add-edit-programmed-alerts';
import AlertCompleteConfirmation from './alert-complete-confirmation';
import OfferNotifyUsers from './offer-notify-users';
import EditAlert from './edit-alert';
import AppointmentRequestPopup from './appointment-request-popup';

const Modal = () => {
  const { modal } = useAppSelector(state => state.modal);
  const { type } = modal;

  const setPopComponent = () => {
    switch (type) {
      case modalEnum.CONFIRMATION:
        return <Confirmation />;
      case modalEnum.COMPLETE_WORKSHOP_APPOINTMENT:
        return <CompleteWorkshopAppointment />;
      case modalEnum.REJECT_WORKSHOP_APPOINTMENT:
        return <CancelledWorkshopAppointment />;
      case modalEnum.ALERT_TEMPLATES:
        return <AlertTemplates />;
      case modalEnum.SEND_ALERT:
        return <SendAlert />;
      case modalEnum.APPOINMENT_CONFIRMATION:
        return <AppointmentConfirmation />;
      case modalEnum.CHANGE_APPOINTMENT_STATUS:
        return <ChangeWorkshopAppointmentStatus />;
      case modalEnum.ADD_PAYMENT:
        return <AddPayment />;
      case modalEnum.ADD_EDIT_BRANDS:
        return <AddEditBrand />;
      case modalEnum.ADD_EDIT_MODELS:
        return <AddEditModel />;
      case modalEnum.ADD_EDIT_ENGINE:
        return <AddEditEngine />;
      case modalEnum.ADD_EDIT_TIRE_SIZE:
        return <AddEditTireSize />;
      case modalEnum.ADD_EDIT_DEVICE_PROVIDER:
        return <AddEditDeviceProvider />;
      case modalEnum.ADD_EDIT_DEVICE:
        return <AddEditDevice />;
      case modalEnum?.ADD_EDIT_PROGRAMMED_ALERTS:
        return <AddEditProgrammedAlert />;
      case modalEnum.ALERT_COMPLETE:
        return <AlertCompleteConfirmation />;
      case modalEnum.OFFER_NOTIFY_USERS:
        return <OfferNotifyUsers />;
      case modalEnum?.EDIT_ALERTS:
        return <EditAlert />;
      case modalEnum.LOGIN_APPOINTMENT_REQUEST:
        return <AppointmentRequestPopup />;
      default:
        return <></>;
    }
  };
  return type ? (
    <div className="absolute inset-0 overflow-y-auto z-10">
      <div className="modal-backdrop bg-black opacity-50 h-screen w-screen"></div>
      <div className="flex items-center justify-center absolute inset-0 bg-transparent">
        <div className="px-6 py-6 w-auto h-auto bg-white rounded-4">
          <div className="modal-content flex flex-1 overflow-y-hidden">{setPopComponent()}</div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default memo(Modal);
